import { BORDER_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import CardBorderNose from "./border/CardBorderNose"
import { ICardProps } from "./Card"
import CardBorderCurve from "./border/CardBorderCurve"
import CardBorderNormal from "./border/CardBorderNormal"

/* Protopia Ecosystem component */  
const CardBorder = (props: ICardProps): JSX.Element => {
    const {data, contentData} = props
    switch( data.borderType || contentData.border?.borderType ) {
        case BORDER_TYPE.NOSE:
            return <CardBorderNose {...props} />
        case BORDER_TYPE.CURVE:
            return <CardBorderCurve {...props} />
        case BORDER_TYPE.NONE:
            return <CardBorderNormal {...props} />
        default:
            return <></>
    }
}
export default CardBorder